import { useCallback, useRef, useState } from "react";

export function usePTT(ws, isForeman = false) {
  const [transmitting, setTransmitting]  = useState(false);
  const [speakingUser, setSpeakingUser]  = useState(null);
  const mediaRef    = useRef(null);
  const recorderRef = useRef(null);
  const audioCtxRef = useRef(null);

  const playAudio = useCallback((arrayBuffer) => {
    if (!audioCtxRef.current)
      audioCtxRef.current = new (window.AudioContext || window.webkitAudioContext)();
    const ctx = audioCtxRef.current;
    ctx.decodeAudioData(arrayBuffer.slice(0)).then((decoded) => {
      const src = ctx.createBufferSource();
      src.buffer = decoded;
      src.connect(ctx.destination);
      src.start();
    }).catch(() => {});
  }, []);

  const handleEvent = useCallback((evt) => {
    if (evt.type === "ptt_start" || evt.type === "foreman_override")
      setSpeakingUser(evt.user_name || evt.user_id);
    if (evt.type === "ptt_end") setSpeakingUser(null);
  }, []);

  const startPTT = useCallback(async (isOverride = false) => {
    if (!ws || ws.readyState !== WebSocket.OPEN) return;
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      mediaRef.current = stream;
      // Foreman override cuts into active transmissions
      ws.send(JSON.stringify({ type: isOverride ? "foreman_override" : "ptt_start" }));
      setTransmitting(true);

      const recorder = new MediaRecorder(stream, { mimeType: "audio/webm;codecs=opus" });
      recorderRef.current = recorder;
      recorder.ondataavailable = (e) => {
        if (e.data.size > 0 && ws.readyState === WebSocket.OPEN)
          e.data.arrayBuffer().then((buf) => ws.send(buf));
      };
      recorder.start(100);
    } catch (err) { console.error("Mic error:", err); }
  }, [ws]);

  const stopPTT = useCallback(() => {
    if (!ws || ws.readyState !== WebSocket.OPEN) return;
    recorderRef.current?.stop();
    mediaRef.current?.getTracks().forEach((t) => t.stop());
    ws.send(JSON.stringify({ type: "ptt_end" }));
    setTransmitting(false);
  }, [ws]);

  return { transmitting, speakingUser, startPTT, stopPTT, playAudio, handleEvent };
}
